import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildAuthRequestHeaders } from "./authRequestHeaders";
import { emitMarketplaceRewardFromResponse } from "./marketplaceRewards";

export async function fetchProjectComments(projectId) {
  const { data } = await axios.get(`${getApiBase()}/projects/${projectId}/comments`, {
    headers: buildAuthRequestHeaders(),
  });
  return data.comments || [];
}

export async function postProjectComment(projectId, { body, parentId }) {
  const { data } = await axios.post(
    `${getApiBase()}/projects/${projectId}/comments`,
    { body, parentId: parentId ?? null },
    { headers: buildAuthRequestHeaders() }
  );
  emitMarketplaceRewardFromResponse(data);
  return data.comment;
}

export async function deleteProjectComment(projectId, commentId) {
  const { data } = await axios.delete(
    `${getApiBase()}/projects/${projectId}/comments/${commentId}`,
    { headers: buildAuthRequestHeaders() }
  );
  return data;
}

export async function uploadCommentAttachment(projectId, commentId, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(
    `${getApiBase()}/projects/${projectId}/comments/${commentId}/attachments`,
    fd,
    {
      headers: buildAuthRequestHeaders(),
      maxBodyLength: 14 * 1024 * 1024,
      maxContentLength: 14 * 1024 * 1024,
    }
  );
  return data.attachment;
}

export async function fetchCommentInbox() {
  const { data } = await axios.get(`${getApiBase()}/me/comment-inbox`, {
    headers: buildAuthRequestHeaders(),
  });
  return data;
}

export async function fetchMentionSuggestions(q) {
  const { data } = await axios.get(`${getApiBase()}/mention-suggestions`, {
    params: { q: q || "" },
    headers: buildAuthRequestHeaders(),
  });
  return data.users || [];
}

export async function downloadCommentAttachment(projectId, commentId, attachmentId, filenameHint) {
  const res = await axios.get(
    `${getApiBase()}/projects/${projectId}/comments/${commentId}/attachments/${attachmentId}`,
    { headers: buildAuthRequestHeaders(), responseType: "blob" }
  );
  const blob = new Blob([res.data]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filenameHint || "attachment";
  a.click();
  URL.revokeObjectURL(url);
}
